import { ClientDO } from "./client.model"
import { PersonDO } from './person.model'
import { OrganisationDO } from './organisation.model'
import { GuidGenerator } from '../../core/utilities/commonUtility';

export class LeadIO {

  public leadDO: LeadDO = new LeadDO;
  public clientDO: ClientDO = new ClientDO;

  constructor() {

  }


  public get $leadDO(): LeadDO {
    return this.leadDO;
  }

  public set $leadDO(value: LeadDO) {
    this.leadDO = value;
  }

  public get $clientDO(): ClientDO {
    return this.clientDO;
  }

  public set $clientDO(value: ClientDO) {
    this.clientDO = value;
  }




}

export class LeadDO {

  private parentObject: any;
  private versionId: any;
  private guid: any;
  private createdDt: string;
  private updatedDt: string;
  private createdUser: any;
  private updatedUser: any;
  private errorFl: boolean;
  private warningFl: boolean;
  private offlineGuid: any;
  private agentDeviceSeq: any;
  public id: number;
  private partnerCd: any;
  private partnerBranchCd: any;
  private agentCd: any;
  public leadNum: any;
  private sourceCd: any;
  private statusCd: any;
  private remarks: string;
  private clientId: number;
  private clientRefGuid: any;
  public leadProductDOList: Array<LeadProductDO>;
  public leadActivityDOList: Array<LeadActivityDO>;
  private objectName: string;

  constructor() {

    this.parentObject = null;
    this.versionId = null;
    this.guid = new GuidGenerator().setGuid();
    this.createdDt = null;
    this.updatedDt = null;
    this.createdUser = null;
    this.updatedUser = null;
    this.errorFl = false;
    this.warningFl = false;
    this.offlineGuid = null;
    this.agentDeviceSeq = null;
    this.id = null;
    this.partnerCd = null;
    this.partnerBranchCd = null;
    this.agentCd = null;
    this.leadNum = null;
    this.sourceCd = null;
    this.statusCd = null;
    this.remarks = null;
    this.clientId = null;
    this.clientRefGuid = null;
    this.leadProductDOList = [];
    this.leadActivityDOList = [];
    this.objectName = 'LeadDO'

  }


  public get $parentObject(): any {
    return this.parentObject;
  }

  public set $parentObject(value: any) {
    this.parentObject = value;
  }


  public get $versionId(): any {
    return this.versionId;
  }

  public set $versionId(value: any) {
    this.versionId = value;
  }


  public get $guid(): any {
    return this.guid;
  }

  public set $guid(value: any) {
    this.guid = value;
  }


  public get $createdDt(): string {
    return this.createdDt;
  }

  public set $createdDt(value: string) {
    this.createdDt = value;
  }

  public get $updatedDt(): string {
    return this.updatedDt;
  }

  public set $updatedDt(value: string) {
    this.updatedDt = value;
  }

  public get $createdUser(): any {
    return this.createdUser;
  }

  public set $createdUser(value: any) {
    this.createdUser = value;
  }

  public get $updatedUser(): any {
    return this.updatedUser;
  }

  public set $updatedUser(value: any) {
    this.updatedUser = value;
  }

  public get $errorFl(): boolean {
    return this.errorFl;
  }

  public set $errorFl(value: boolean) {
    this.errorFl = value;
  }

  public get $warningFl(): boolean {
    return this.warningFl;
  }

  public set $warningFl(value: boolean) {
    this.warningFl = value;
  }

  public get $offlineGuid(): any {
    return this.offlineGuid;
  }

  public set $offlineGuid(value: any) {
    this.offlineGuid = value;
  }

  public get $agentDeviceSeq(): any {
    return this.agentDeviceSeq;
  }

  public set $agentDeviceSeq(value: any) {
    this.agentDeviceSeq = value;
  }

  public get $id(): number {
    return this.id;
  }

  public set $id(value: number) {
    this.id = value;
  }

  public get $partnerCd(): any {
    return this.partnerCd;
  }

  public set $partnerCd(value: any) {
    this.partnerCd = value;
  }

  public get $partnerBranchCd(): any {
    return this.partnerBranchCd;
  }

  public set $partnerBranchCd(value: any) {
    this.partnerBranchCd = value;
  }

  public get $agentCd(): any {
    return this.agentCd;
  }

  public set $agentCd(value: any) {
    this.agentCd = value;
  }

  public get $leadNum(): any {
    return this.leadNum;
  }

  public set $leadNum(value: any) {
    this.leadNum = value;
  }

  public get $sourceCd(): any {
    return this.sourceCd;
  }

  public set $sourceCd(value: any) {
    this.sourceCd = value;
  }

  public get $statusCd(): any {
    return this.statusCd;
  }

  public set $statusCd(value: any) {
    this.statusCd = value;
  }

  public get $remarks(): string {
    return this.remarks;
  }

  public set $remarks(value: string) {
    this.remarks = value;
  }

  public get $clientId(): number {
    return this.clientId;
  }

  public set $clientId(value: number) {
    this.clientId = value;
  }

  public get $clientRefGuid(): any {
    return this.clientRefGuid;
  }

  public set $clientRefGuid(value: any) {
    this.clientRefGuid = value;
  }

  public get $leadProductDOList(): Array<LeadProductDO> {
    return this.leadProductDOList;
  }

  public set $leadProductDOList(value: Array<LeadProductDO>) {
    this.leadProductDOList = value;
  }

  public get $leadActivityDOList(): Array<LeadActivityDO> {
    return this.leadActivityDOList;
  }

  public set $leadActivityDOList(value: Array<LeadActivityDO>) {
    this.leadActivityDOList = value;
  }

  public get $objectName(): string {
    return this.objectName;
  }

  public set $objectName(value: string) {
    this.objectName = value;
  }



}

export class LeadProductDO {
  private parentObject: string;
  private versionId: number;
  private guid: any;
  private createdDt: string;
  private updatedDt: string;
  private createdUser: string;
  private updatedUser: string;
  private id: number;
  private productCd: any;
  private productFamilyCd: any;
  private objectName: string;

  constructor() {
    this.parentObject = null;
    this.versionId = null;
    this.guid = new GuidGenerator().setGuid();
    this.createdDt = null;
    this.updatedDt = null;
    this.createdUser = null;
    this.updatedUser = null;
    this.id = null;
    this.productCd = null;
    this.productFamilyCd = null;
    this.objectName = "LeadProductDO"
  }


  public get $parentObject(): string {
    return this.parentObject;
  }

  public set $parentObject(value: string) {
    this.parentObject = value;
  }

  public get $versionId(): number {
    return this.versionId;
  }

  public set $versionId(value: number) {
    this.versionId = value;
  }

  public get $guid(): any {
    return this.guid;
  }

  public set $guid(value: any) {
    this.guid = value;
  }


  public get $createdDt(): string {
    return this.createdDt;
  }

  public set $createdDt(value: string) {
    this.createdDt = value;
  }

  public get $updatedDt(): string {
    return this.updatedDt;
  }

  public set $updatedDt(value: string) {
    this.updatedDt = value;
  }

  public get $createdUser(): string {
    return this.createdUser;
  }

  public set $createdUser(value: string) {
    this.createdUser = value;
  }

  public get $updatedUser(): string {
    return this.updatedUser;
  }

  public set $updatedUser(value: string) {
    this.updatedUser = value;
  }

  public get $id(): number {
    return this.id;
  }

  public set $id(value: number) {
    this.id = value;
  }

  public get $productCd(): any {
    return this.productCd;
  }

  public set $productCd(value: any) {
    this.productCd = value;
  }

  public get $productFamilyCd(): any {
    return this.productFamilyCd;
  }

  public set $productFamilyCd(value: any) {
    this.productFamilyCd = value;
  }

  public get $objectName(): string {
    return this.objectName;
  }

  public set $objectName(value: string) {
    this.objectName = value;
  }

}

export class LeadActivityDO {
  private parentObject: any;
  private versionId: any;
  private guid: any;
  private createdDt: any;
  private updatedDt: any;
  private createdUser: any;
  private updatedUser: any;
  private id: any;
  private typeCd: any;
  private statusCd: any;
  private remarks: any;
  private scheduledDt: any;
  private objectName: any;

  constructor() {
    this.initializeValues();
  }


  public initializeValues(TypeCd?, Remarks?, ScheduledDt?) {
    this.parentObject = null;
    this.versionId = null;
    this.guid = new GuidGenerator().setGuid();
    this.createdDt = null;
    this.updatedDt = null;
    this.createdUser = null;
    this.updatedUser = null;
    this.id = null;
    this.statusCd = null;
    this.typeCd = TypeCd;
    this.remarks = Remarks;
    this.scheduledDt = ScheduledDt;
    this.objectName = "LeadActivityDO"
  }


  public get $parentObject(): any {
    return this.parentObject;
  }

  public set $parentObject(value: any) {
    this.parentObject = value;
  }

  public get $versionId(): any {
    return this.versionId;
  }

  public set $versionId(value: any) {
    this.versionId = value;
  }

  public get $guid(): any {
    return this.guid;
  }

  public set $guid(value: any) {
    this.guid = value;
  }

  public get $createdDt(): any {
    return this.createdDt;
  }

  public set $createdDt(value: any) {
    this.createdDt = value;
  }

  public get $updatedDt(): any {
    return this.updatedDt;
  }

  public set $updatedDt(value: any) {
    this.updatedDt = value;
  }

  public get $createdUser(): any {
    return this.createdUser;
  }

  public set $createdUser(value: any) {
    this.createdUser = value;
  }

  public get $updatedUser(): any {
    return this.updatedUser;
  }

  public set $updatedUser(value: any) {
    this.updatedUser = value;
  }

  public get $id(): any {
    return this.id;
  }

  public set $id(value: any) {
    this.id = value;
  }

  public get $typeCd(): any {
    return this.typeCd;
  }

  public set $typeCd(value: any) {
    this.typeCd = value;
  }

  public get $statusCd(): any {
    return this.statusCd;
  }

  public set $statusCd(value: any) {
    this.statusCd = value;
  }

  public get $remarks(): any {
    return this.remarks;
  }

  public set $remarks(value: any) {
    this.remarks = value;
  }

  public get $scheduledDt(): any {
    return this.scheduledDt;
  }

  public set $scheduledDt(value: any) {
    this.scheduledDt = value;
  }

  public get $objectName(): any {
    return this.objectName;
  }

  public set $objectName(value: any) {
    this.objectName = value;
  }

}
